import { render, staticRenderFns } from "./chose_freight_template.vue?vue&type=template&id=32fcf5bb&scoped=true"
import script from "./chose_freight_template.vue?vue&type=script&lang=js"
export * from "./chose_freight_template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fcf5bb",
  null
  
)

export default component.exports